import React, { useCallback, useEffect } from "react";
import axios from "axios"
import semver from "semver";
import UpdatePackage from "./UpdatePackage";
import Loader from "./Loader";


const states = {
    FETCHPACKAGES: 1,
    UPDATING: 2,
    FINISHING: 3,
    UPDATED: 4,
};

const CheckUpdates = ({ session, onSuccess, onPackages }) => {

    const [storeManifest, setStoreManifest] = React.useState();
    const [installedPackages, setInstalledPackages] = React.useState();
    const [toUpdate, setToUpdate] = React.useState();
    const [viewState, setViewState] = React.useState(states.FETCHPACKAGES);


    const printState = (state) => {
        const foundKey = Object.keys(states).find((k) => {
            return states[k] === state;
        });
        return foundKey;
    }

    const peerConnect = (peer) => {
        console.log(`connecting to IPFS ${peer}`);
        const apiLink = `http://172.33.1.5:5001/api/v0/swarm/connect?arg=${peer}`;
        axios
            .post(
                apiLink
            )
            .then(res => {
                // console.log(res);
                console.log(`connected to ${apiLink}`);
            })
            .catch(error => {
                console.log(`Failed to connect to ${apiLink}`, error.message);
            });
    };

    const getStore = async () => {
        try {
            const r = await axios.get("https://bo.ava.do/value/store");

            const storeRes = JSON.parse(r.data);

            if (storeRes && storeRes.ipfsHostNodes) {
                storeRes.ipfsHostNodes.map(peerConnect);
            }

            const storeHash = storeRes.hash;

            return axios
                .get(
                    `http://172.33.1.5:8080/ipfs/${storeHash}`
                )
                .then(res => {
                    const storeManifest = res.data;
                    return (storeManifest);
                    // setStoreManifest(storeManifest);
                })
                .catch(error => {
                    console.log(error);
                    return null;
                });

        } catch (e) {
            return null;
            // setError(`Cannot download store`);
        }
    };

    const getPackages = async () => {
        return session.call("listPackages.dappmanager.dnp.dappnode.eth")
            .then(res => {
                res = JSON.parse(res);
                if (!res || !res.result) {
                    throw new Error(`cannot find any packages on your AVADO`);
                }
                onPackages && onPackages(res.result);
                return (res.result);
            })
            .catch((e) => {
                console.log(`${e.messsage}`);
                return null;
            });
    };

    const resetDNS = async () => {
        console.log(`Reset BIND package`);
        await session.call("restartPackageVolumes.dappmanager.dnp.dappnode.eth", [], {
            id: "bind.dnp.dappnode.eth",
        }).then(res => {
            console.log(`Reset BIND package success`);
        }).catch((e) => {
            console.log(`Cannot reset BIND package ${e.messsage}`);
        });
    }

    React.useEffect(() => {
        console.log("starting CheckUpdates component")
        if (session) {
            getPackages().then(setInstalledPackages);
            getStore().then(setStoreManifest);
        }
    }, [session]);

    React.useEffect(() => {
        if (storeManifest && installedPackages) {
            let toUpdate = storeManifest.packages.sort((a, b) => { return (a.manifest.name > b.manifest.name) ? 1 : -1 })
                .reduce((accum, p, i) => {
                    const installedVersion = installedPackages.find((installedPackage) => {
                        return (p.manifest.name === installedPackage.name)
                    })
                    if (installedVersion) {
                        console.log(`checking package ${p.manifest.name} ${p.manifest.version}`);
                        console.log(`I have version ${installedVersion.version} installed`)
                        if (semver.gt(p.manifest.version, installedVersion.version)) {
                            accum.push(`${p.manifest.name}@${p.manifesthash}`);
                        }
                    }
                    return accum;
                }, []);
            console.log(`packages to update`, toUpdate);
            setToUpdate(toUpdate);
        }
    }, [storeManifest, installedPackages]);

    React.useEffect(() => {
        const transitionTo = (newState) => {
            console.log(`CheckUpdates: going from state  ${printState(viewState)} to ${printState(newState)}`);
            if (viewState === newState) {
                console.log(`from and to state are the same`);
                return;
            }
            switch (newState) {
                case states.UPDATING:
                    if (viewState === states.FETCHPACKAGES)
                        setViewState(newState);
                    break;
                case states.FINISHING:
                    if ([states.UPDATING].includes(viewState)) {
                        setViewState(newState);
                    }
                    break;
                case states.UPDATED:
                    if ([states.FINISHING, states.FETCHPACKAGES, states.UPDATING].includes(viewState)) {
                        setViewState(newState);
                    }
                    break;
                default:
                    console.log("unknown target state");
            }
        };

        if (toUpdate && toUpdate.length === 0) {
            transitionTo(states.FINISHING);
            console.log("All done updating packages");
            resetDNS().then(() => {
                transitionTo(states.UPDATED);
                onSuccess();
            })
        } else {
            transitionTo(states.UPDATING);
        }
    }, [toUpdate]);



    if (viewState === states.FETCHPACKAGES) {
        return (<div>Fetching package updates <Loader /></div>);
    }
    if (viewState === states.UPDATING) {
        if (!toUpdate) {
            return null;
        }
        const packageToUpdate = toUpdate[0];
        return (
            <>
                <UpdatePackage id={packageToUpdate} session={session} onSuccess={(updatedPackageManifestHash) => {
                    const filteredList = toUpdate.filter(item => item !== updatedPackageManifestHash);
                    setToUpdate(filteredList);
                    console.log(`updated ${packageToUpdate}`);
                }} /><br />
                {toUpdate > 0 && (
                    <p>{toUpdate.length} update{toUpdate.length > 1 ? "s" : ""} remaining</p>
                )}
            </>
        );
    }
    if (viewState === states.FINISHING) {
        return (<div>Finishing up &nbsp;<Loader /></div>);
    }

    if (viewState === states.UPDATED) {
        return (<div>Everything updated</div>);
    }
}

export default CheckUpdates;
